<template>
    <div id="chat-closed">

        <div class="disclaimer">
            {{ $t('CHAT_CLOSED_DISCLAIMER') }}
        </div>

        <v-btn 
            @click="handleNewChat"
            :disabled="requestInProgress" 
            elevation="1"
        >{{ $t('NEW_CHAT') }}</v-btn>

    </div>
</template>

<script>
    import { mapActions } from "vuex";

    export default {
        name: 'ChatClosed',
        data() {
            return {
                formData: {
                    origin: 'proteus',
                },
                inProgress: false,
            };
        },
        methods: {
            ...mapActions(["resetApp"]),
            async handleNewChat(e) {
                e.preventDefault();
                this.setInProgress(true);

                await this.clearChatIdCookie();
                await this.resetApp();

                this.setInProgress(false);
            },
            clearChatIdCookie() {
                this.$cookies.remove('qabotChatId');
            },
            setInProgress(inProgress) {
                this.inProgress = inProgress;
            },
        },
        computed: {
            requestInProgress() {
                return this.inProgress;
            },
        },
    }
</script>